import CryptoJS from "crypto-js";

const SECRET_KEY = "d036b6ecbf214c7781c5f7c397dcc4bf";

export function encryptPayload(payload) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    CryptoJS.enc.Base64.parse(SECRET_KEY),
    {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }
  );
  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
  const cipherTextBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const combinedBase64 = ivBase64 + ":" + cipherTextBase64;
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(combinedBase64));
}

export function decryptPayload(payload) {
  try {
    const combinedText = CryptoJS.enc.Base64.parse(payload).toString(
      CryptoJS.enc.Utf8
    );
    const parts = combinedText.split(":");
    if (parts.length !== 2) {
      throw new Error("Invalid encrypted payload format");
    }
    const ivBase64 = parts[0];
    const encryptedTextBase64 = parts[1];
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encryptedText = CryptoJS.enc.Base64.parse(encryptedTextBase64);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: encryptedText,
    });
    const decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      CryptoJS.enc.Base64.parse(SECRET_KEY),
      {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedText || decryptedText.trim() === "") {
      throw new Error("Decryption resulted in empty string");
    }

    return decryptedText;
  } catch (error) {
    throw new Error("Decryption failed: " + error.message);
  }
}
